<template>
  <div class="main">

    <v-container fill-height fluid justify-center>
      <v-layout wrap>
        <v-flex xs10 offset-xs1 class="mt-5">
          <v-card color="blue lighten-2" class="card-styl text-xs-center">
            <p v-text="title" class="not-found-message"></p>
            <a :href="homelink" class="alink">Go To timmyskittys.com</a>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- This is hack to get the background to fill the page. Still need to determine how to fix. -->
    <v-container fill-height fluid justify-center>
      <v-layout wrap class="filler">
      </v-layout>
    </v-container>

    <v-container>
      <v-layout class="footer">
        <footer-view></footer-view>
      </v-layout>
    </v-container>

  </div>
</template>

<script>
/* eslint-disable */
import FooterView from "./FooterView";

export default {
  components: {
    FooterView
  },
 data: () => ({
    title: "404 Not Found. Sorry, the page you are requesting was not found.",
    homelink: 'https://www.timmyskittys.com'
  }),
};
</script>

<style scoped>
.main {
  background-image: url("../img/background_colored_paws_1200_983.jpg");
  background-color: #f8f8ff;
  background-repeat: no-repeat;
  background-size: cover;
  max-width: '100%';
  height: '100%';
}
.alink {
  text-decoration: none;
  list-style-type: none;
  font-size: 1.5rem;
  color: #f00;
  font-weight: bold;
}
.not-found-message {
  font-size: 1.8rem;
  font-weight: bolder;
}
.card-styl {
  margin-top: 150px;
}
.filler {
  margin-top: 200px;
}
</style>


// WEBPACK FOOTER //
// src/components/NotFound404.vue